import { icon } from '../../../engine/icons';
import { adminListInvoices, listItems, type AdminInvoice } from '../admin-api';
import { escapeHtml, money, when, SMALL_BTN_CLS } from '../admin-ui';
import { openGenerateInvoice } from '../modals/generate-invoice';
import type { PaneModule } from './types';

const STATUS_CLS: Record<string, string> = {
  PAID: 'text-success',
  PENDING: 'text-gold',
  CANCELLED: 'text-text-dim',
};

function rowHtml(i: AdminInvoice): string {
  return `
    <tr class="border-t border-border">
      <td class="py-2 pr-3 text-sm text-text whitespace-nowrap">${escapeHtml(i.number)}</td>
      <td class="py-2 pr-3 text-[10px] text-text-dim whitespace-nowrap">${escapeHtml(when(i.createdAt))}</td>
      <td class="py-2 pr-3 text-xs text-text-dim min-w-40">${escapeHtml(i.description)}</td>
      <td class="py-2 pr-3 text-[10px] whitespace-nowrap ${STATUS_CLS[i.status] ?? 'text-text-dim'}">${escapeHtml(i.status)}</td>
      <td class="py-2 pr-3 text-sm text-text tabular-nums text-right whitespace-nowrap">${money(i.totalCents, i.currency)}</td>
      <td class="py-2 text-right whitespace-nowrap">
        <!-- A real link, not a fetch-to-blob: a direct navigation is what
             makes Content-Disposition: attachment download rather than
             render, and it carries the session cookie automatically. -->
        <a class="${SMALL_BTN_CLS} inline-flex items-center justify-center w-11"
          href="/api/admin/invoices/${encodeURIComponent(i.number)}/download"
          target="_blank" rel="noopener noreferrer"
          title="Download ${escapeHtml(i.number)} as PDF" aria-label="Download ${escapeHtml(i.number)} as PDF">
          <span class="w-3.5 h-3.5 block">${icon('filePdf')}</span>
        </a>
      </td>
    </tr>`;
}

export const invoicesPane: PaneModule = {
  id: 'invoices',
  label: 'Invoices',

  html(ctx) {
    const rows = ctx.state.invoices.items.map(rowHtml).join('');
    return `
      <section class="flex flex-col gap-2">
        <div class="flex items-center justify-between gap-2">
          <h2 class="font-heading text-xs text-gold tracking-wide uppercase">Invoices</h2>
          <button type="button" class="${SMALL_BTN_CLS}" data-action="generate-invoice">+ Generate invoice</button>
        </div>
        <div class="glass-panel px-3 py-2 overflow-x-auto">
          <table class="w-full text-left">
            <thead>
              <tr class="text-[10px] text-text-dim uppercase tracking-wide">
                <th class="py-1 pr-3 font-normal">Number</th>
                <th class="py-1 pr-3 font-normal">Date</th>
                <th class="py-1 pr-3 font-normal">Content</th>
                <th class="py-1 pr-3 font-normal">Status</th>
                <th class="py-1 pr-3 font-normal text-right">Amount</th>
                <th class="py-1 font-normal text-right">PDF</th>
              </tr>
            </thead>
            <tbody>${rows || '<tr><td colspan="6" class="py-3 text-xs text-text-dim">No invoices yet.</td></tr>'}</tbody>
          </table>
        </div>
      </section>`;
  },

  async load(ctx) {
    ctx.state.invoices.items = listItems(await adminListInvoices());
  },

  onAction(action, _el, ctx) {
    if (action !== 'generate-invoice') return false;
    openGenerateInvoice(ctx);
    return true;
  },
};
